import Header from "../../../components/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import Accordion from "../../../components/Accordion";
import AccordionItem from "../../../components/Accordion/AccordionItem";
import clsx from "clsx";
import { Fragment, useEffect, useRef } from "react";
import FaqsContent from './Faqs.json';
import { FbPixelEvent_PageView } from "../../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../../utils/helpers/common";
import { FACEBOOK } from "../../../utils/helpers/constants";
const FaqPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const language = localStorage.getItem('language') || "en";
  const faqContent = (language === 'en') ? FaqsContent.faq_en : FaqsContent.faq_hi;
  const hasTrackedRef = useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);
  return (
    <>
      <Header pageTitle={t('faqLabel')} navigate={() => navigate(-1)} />
      <div className={clsx(styles.pageWrapper, "pageWrapper")}>
        <h1 className={clsx(styles.faqHeading, "faqHeading")}>{t('faqLabel')}</h1>
        <Accordion >
          {faqContent.map((item, index) => {
            return (
              <Fragment key={index}>
                <AccordionItem
                  title={item.heading}
                  accordionInnerContentClassName={clsx(styles.accordionInnerContent)}
                  backgroundColor="gray"
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: item?.content }}
                  />
                </AccordionItem>
                <hr className={styles.horizontalLine} />
              </Fragment>
            )
          })}
        </Accordion>
        <div className={styles.emailBlock}>
          <p>{t('reachOutAtEmail')} : <a href="mailto:care@zupee.com" className={styles.mailtoAnchor}>care@zupee.com</a> </p>
        </div>
      </div>
    </>
  )
}
export default FaqPage;